import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from 'react-router-dom';
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import Select, { SelectInstance } from "react-select";
import {
  updateDocStatus,
  getBusinessById,
  getStates,
  getDistricts,
  getCities,
  getBusinessDocs,
  updateDocStatusByBusiness,
  updateBusiness,
  addBusinessDoc,
  uploadBusinessImage,
  getSalesReps,
  getSalesRepByBusinessId,
  addSalesRep,
  updateSalesRep,
  deleteSalesRep
} from "../../../helpers/backend_helper";
import { Pencil, Search, Trash2, Plus, Link2, Link2Icon, UploadCloud } from "lucide-react";

import { Common } from "helpers/common";
import { ChevronDown, ChevronUp, Loader2 } from "lucide-react";

import { BusinessType } from "types/BusinessType";
import { RegionType } from "types/RegionType";
import { ToastContainer } from "react-toastify";
import { BusinessDocType } from "types/BusinessDocType";
import moment from "moment";
import { BusinessDocuments, getImageUrl } from "constants/constants";
import { IMAGE_FOLDER } from "constants/settings";
import { BusinessDetailForm } from "./BusinessDetailForm";

export const BusinessDetails = () => {
  const { businessId } = useParams();
  const [businessInfo, setBusinessInfo] = useState<BusinessType>();
  const [businessDocs, setBusinessDocs] = useState<BusinessDocType[]>([]);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isBDocSaving, setIsBDocSaving] = useState<boolean>(false);
  const [isNewBDocSaving, setIsNewBDocSaving] = useState<boolean>(false);
  const commonHelper = new Common();
  const districtRef = useRef<SelectInstance<RegionType> | null>(null)
  const cityRef = useRef<SelectInstance<RegionType> | null>(null)

  const [states, setStates] = useState<RegionType[]>([]);
  const [districts, setDistricts] = useState<RegionType[]>([]);
  const [cities, setCities] = useState<RegionType[]>([]);

  const [selectedState, setSelectedState] = useState<any>();
  const [selectedCity, setSelectedCity] = useState<any>();
  const [selectedDistrict, setSelectedDistrict] = useState<any>();
  const [selectedFile, setSelectedFile] = useState<any>();
  const [selectedDocumentName, setSelectedDocumentName] = useState<any>(BusinessDocuments[0].title);
  const [documentNames, setDocumentNames] = useState<any[]>([]);
  const [salesReps, setSalesReps] = useState<any[]>([]);
  const [selectedSalesRep, setSelectedSalesRep] = useState<any>();
  const [businessSalesRepId, setBusinessSalesRepId] = useState<number>(0);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (businessInfo?.id) {
      loadStates();
    }
    console.log('businessInfo?.id', businessInfo?.id);
  }, [businessInfo?.id]);


  const loadData = async () => {
    await loadBusinessInfo();
    await loadSalesReps();
    await loadBusinessDocs();
  };

  const loadSalesReps = async () => {
    let response = await getSalesReps();
    if (response.success) {
      const items = [{ value: '', label: 'Select' }, ...(response.data as any[]).map(item => ({ value: item.id, label: item.fullName }))];
      setSalesReps(items);
      loadSalesRepByBusinessId(items);
    }
  };


  const loadSalesRepByBusinessId = async (salesRepre: any[]) => {
    try {
      let response = await getSalesRepByBusinessId(businessId);
      if (response.success) {
        const resSalesRep = response.data && response.data[0] as any;
        const selectedSalesRep = salesRepre?.find(i => i.value == resSalesRep?.userId);
        console.log('sales reps', response.data, salesRepre, selectedSalesRep)
        setSelectedSalesRep(selectedSalesRep);
        setBusinessSalesRepId(resSalesRep?.id);
      }
    } catch (e) { }
  }

  const saveSalesRep = async () => {

    console.log('selectedSalesRep', selectedSalesRep)

    if (!selectedSalesRep) {
      return;
    }

    if (selectedSalesRep?.value == '' && businessSalesRepId > 0) {
      // delete the sales rep and business mapping
      const response = await deleteSalesRep(businessSalesRepId);
      console.log('sales rep delete response', response);

      return;
    }
    try {
      const data = {
        businessId: businessId,
        userId: selectedSalesRep.value,
        isActive: true,
      }

      const response = businessSalesRepId > 0 ? await updateSalesRep(data, businessSalesRepId) : await addSalesRep(data);
      console.log('sales rep save response', response);
    } catch (error) {
      console.log('API-Error', error);
      commonHelper.showErrorMessage(error as string);
    }
    setIsSaving(false);
  }


  const loadStates = async () => {
    if (states.length === 0) {

      let response = await getStates();
      console.log('states', response)
      console.log('businessInfo', businessInfo);

      if (response.success) {
        const items = [{ value: '', label: 'Select' }, ...(response.data as any[]).map(item => ({ value: item.id, label: item.name }))]
        setStates(items);
        console.log('businessInfo?.stateId', businessInfo?.stateId);
        if (businessInfo?.stateId) {
          setSelectedState(items?.find(i => i.value == businessInfo?.stateId));
        }
      }

      if (businessInfo?.id) {
        await loadDistrict(businessInfo.stateId.toString());
        await loadCities(businessInfo.districtId.toString());
      }
    }
  }

  const loadDistrict = async (stateId: string) => {
    if (!stateId)
      return;

    var params = 'value=' + stateId;
    console.log(params);
    try {
      let response = await getDistricts(params)
      console.log('districts', response)

      if (response.success) {
        const items = [{ value: '', label: 'Select' }, ...(response.data as any[]).map(item => ({ value: item.id, label: item.name }))]
        setDistricts(items);
        if (businessInfo?.districtId) {
          setSelectedDistrict(items?.find(i => i.value == businessInfo?.districtId));
        }
      }
    } catch (err) {
      console.log(err);
      commonHelper.showErrorMessage('No district found for selected state.')
    }
  }

  const loadCities = async (districtId: string) => {
    if (!districtId)
      return;

    var params = 'value=' + districtId;
    try {

      let response = await getCities(params)
      console.log('cities', response)

      if (response.success) {
        const items = [{ value: '', label: 'Select' }, ...(response.data as any[]).map(item => ({ value: item.id, label: item.name }))]
        setCities(items);
        if (businessInfo?.cityId) {
          setSelectedCity(items?.find(i => i.value == businessInfo?.cityId));
        }
      }
    } catch (err) {
      console.log(err);
      commonHelper.showErrorMessage('No city found for selected district.')
    }
  }

  const handleStateSelection = async (item: any) => {
    districtRef?.current?.clearValue();
    setSelectedState(item);
    setDistricts([]);
    setSelectedDistrict({});
    validation.setFieldValue(
      'stateId',
      item.value
    );

    loadDistrict(item.value)
  }

  const handleDistrictSelection = async (item: any) => {
    if (item) {
      cityRef?.current?.clearValue();
      setSelectedDistrict(item);
      setSelectedCity({} as RegionType);
      setCities([]);
      validation.setFieldValue(
        'districtId',
        item.value
      )
      loadCities(item.value);
    }
  }

  const handleCitySelection = (item: any) => {
    setSelectedCity(item);

    if (item) {
      console.log('selected state', item.value)
      validation.setFieldValue('cityId', item.value);
    }
  }

  const handleSalesRepSelection = (item: any) => {
    setSelectedSalesRep(item);
  }


  async function loadBusinessInfo() {
    try {
      const response = await getBusinessById(businessId as string);
      const responseData = response.data as BusinessType[];
      setBusinessInfo(responseData[0]);
      console.log(responseData[0]);


    } catch (error) {
      console.error("Error loading business info", error);
      commonHelper.showErrorMessage("Error loading business info");
    }
  }


  async function loadBusinessDocs() {
    try {
      const response = await getBusinessDocs(businessId as string);
      const responseData = response.data as BusinessDocType[];

      const sortedData = responseData.sort((a, b) => a.id - b.id);

      setBusinessDocs(sortedData);
      console.log('business dcos', sortedData);

    } catch (error) {
      console.error("Error loading roles", error);
    }
  }



  // validation for Business Information
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (businessInfo && businessInfo?.id) || "0",
      // documentRejectedReason: (businessInfo && businessInfo?.documentRejectedReason) || "",
      // documentVerified: true,

      // userId: (businessInfo && businessInfo?.userId) || "0",
      businessName: (businessInfo && businessInfo?.businessName) || "",
      gstNo: (businessInfo && businessInfo?.gstNo) || "",
      pan: (businessInfo && businessInfo?.pan) || "",
      ownerName: (businessInfo && businessInfo?.ownerName) || "",
      businessEstablishmentYear: (businessInfo && businessInfo?.businessEstablishmentYear) || "",
      businessType: (businessInfo && businessInfo?.businessType) || "",
      addressLine1: (businessInfo && businessInfo?.addressLine1) || "",
      addressLine2: (businessInfo && businessInfo?.addressLine2) || "",
      landmark: (businessInfo && businessInfo?.landmark) || "",
      stateId: (businessInfo && businessInfo?.stateId) || "",
      districtId: (businessInfo && businessInfo?.districtId) || "",
      cityId: (businessInfo && businessInfo?.cityId) || "",
      cityName: (businessInfo && businessInfo?.cityName) || "",
      countryId: (businessInfo && businessInfo?.countryId) || 1,
      pinCode: (businessInfo && businessInfo?.pinCode) || "",
      businessLogo: (businessInfo && businessInfo?.businessLogo) || "",
      businessDescription: (businessInfo && businessInfo?.businessDescription) || "",
      businessTagLine: (businessInfo && businessInfo?.businessTagLine) || "",
      contactPerson: (businessInfo && businessInfo?.contactPerson) || "",
      contactPhone: (businessInfo && businessInfo?.contactPhone) || "",
      contactEmail: (businessInfo && businessInfo?.contactEmail) || "",
      website: (businessInfo && businessInfo?.website) || "",
      additionalDiscount: (businessInfo && businessInfo?.additionalDiscount) || "0",
      // docStatus: (businessInfo && businessInfo?.docStatus) || "",
    },
    validationSchema: Yup.object({
      documentRejectedReason: Yup.string(),
    }),

    onSubmit: async (values: any) => {
      setIsSaving(true);
      console.log(values);
      try {
        var result = await updateBusiness(values);

        saveSalesRep();
        commonHelper.showSuccessMessage(`Business info has been successfully updated.`);
        setIsSaving(false);

        console.log(result.data);
      } catch (error: any) {
        console.error("API-Error", error.response.data);
        commonHelper.showErrorMessage(error.response.data.message);
        setIsSaving(false);
      }
    },
  });


  const handleDocStatusChange = (index: number, value: string) => {
    console.log("handleDocStatusChange", index, value);
    const updatedDoc = [...businessDocs];
    updatedDoc[index].documentVerified = value === 'true' ? true : false;
    setBusinessDocs(updatedDoc); // Update the state
  };

  const handleDocCommentChange = (index: number, value: string) => {
    console.log("handleDocCommentChange", index, value);
    const updatedDoc = [...businessDocs];
    updatedDoc[index].documentRejectedReason = value;
    setBusinessDocs(updatedDoc); // Update the state
  };


  const handleDocStatusUpdate = async (index: number) => {
    console.log('Updated record:', businessDocs[index]);
    let error = '';

    if (!businessDocs[index].documentRejectedReason || businessDocs[index].documentRejectedReason.length < 2) {
      error = 'Please enter status comment.';
    }

    if (businessDocs[index].documentVerified === null) {
      error = 'Please select a status.';
    }

    const updatedDoc = [...businessDocs];
    updatedDoc[index].error = error;
    setBusinessDocs(updatedDoc); // Update the state

    if (!error) {
      try {
        const result = await updateDocStatus(businessDocs[index]);
        console.log(result.data);
        commonHelper.showSuccessMessage(`Document status has been successfully updated.`);
      } catch (error: any) {
        console.error("API-Error", error.response.data);
        commonHelper.showErrorMessage(error.response.data.message);
      }
    }
  };


  // validation for Business Docs
  const validationBDoc: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: businessId  ,
      docStatus: (businessInfo && businessInfo?.docStatus) || "",
      documentRejectedReason: "",
      documentVerified: true,
    },
    validationSchema: Yup.object({
      documentRejectedReason: Yup.string()//.required("Status comment is required."),
    }),

    onSubmit: async (values: any) => {
      setIsBDocSaving(true);
      console.log('values', values);
      try {

        let data = { ...values };
        delete data?.id;

        console.log('data', data, values);

        //values={...values, docStatus: values.docBStatus};
        var result = await updateDocStatusByBusiness(data, values?.id);

        commonHelper.showSuccessMessage(`Business document status has been successfully updated.`);
        // console.log(result.data);
      } catch (error: any) {
        console.error("API-Error", error.response.data);
        commonHelper.showErrorMessage(error.response.data.message);
        setIsBDocSaving(false);
      }
      finally {
        setIsBDocSaving(false);
      }
    },
  });


  // validation for New Business Docs
  const validationNewBDoc: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      businessId: businessId,
      documentName: '',
      documentNumber: '',
      documentUrl: '',
      isActive: true,
    },
    validationSchema: Yup.object({
      documentName: Yup.string().required("Document name is required."),
      documentNumber: Yup.string().required("Document# is required."),
      documentUrl: Yup.string().required("Please upload document."),
    }),

    onSubmit: async (values: any) => {
      setIsNewBDocSaving(true);
      console.log('values', values);
      try {

        let logo = null;
        console.log(selectedFile)

        // upload if any new images is selected..
        if (selectedFile?.name) {
          var imgResult = await uploadBusinessImage({ fileCollection: selectedFile }, IMAGE_FOLDER);
          console.log(imgResult);
          logo = imgResult?.data.rows[0].url;
        }


        let data = { ...values, documentRejectedReason: "", documentVerified: true, };
        data.documentUrl = logo;

        console.log('data', data, values);

        var result = await addBusinessDoc(data);

        console.log(result);
        commonHelper.showSuccessMessage(`Business document status has been successfully updated.`);
        clearNewBusinessDocs();
        loadBusinessDocs();
        // console.log(result.data);
      } catch (error: any) {
        console.error("API-Error", error.response.data);
        commonHelper.showErrorMessage(error.response.data.message);
        setIsNewBDocSaving(false);
      }
      finally {
        setIsNewBDocSaving(false);
      }
    },
  });

  const clearNewBusinessDocs = () => {
    validationNewBDoc.setFieldValue('documentName', '');
    validationNewBDoc.setFieldValue('documentNumber', '');
    validationNewBDoc.setFieldValue('documentUrl', '');
  }


  const onFileChange = (event: any) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    validationNewBDoc.setFieldValue('documentUrl', file);
  }

  const handleDocumentNameSelection = (item: any) => {
    if (item) {
      console.log(item)

      validationNewBDoc.setFieldValue('documentName', item.label);
      setSelectedDocumentName(item);
    }
  }



  const handleNewDocStatusChange = (value: any) => {
    console.log("handleNewDocStatusChange", value);
    validationNewBDoc.setFieldValue('isActive', value === "Approve" ? true : false);

  };

  if (!businessId) {
    return null;
  }

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
        <div className="xl:col-span-6">
          <div className="card">
            <h4 className="text-15" style={{ marginLeft: 20, marginTop: 10 }} >Business Information</h4>
            <div className="ltr:ml-auto rtl:mr-auto shrink-0">
            </div>
            <div className="card-body">
              <BusinessDetailForm businessId={businessId} userId={'0'} onSave={() => {}} />  
            </div>
          </div>

          <div className="card">
            <h4 className="text-15" style={{ marginLeft: 20, marginTop: 10 }} >Business Status</h4>
            <div className="ltr:ml-auto rtl:mr-auto shrink-0">
            </div>
            <div className="card-body">
              <form action="#!!" onSubmit={(e) => {
                e.preventDefault();
                validationBDoc.handleSubmit();
                return false;
              }}>
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                  <div className="xl:col-span-12">
                    <div className="flex flex-wrap gap-2">
                      <label htmlFor="docStatus" className="inline-block text-base font-medium">Status<span className='redColor'>*</span></label>


                      <div className="flex items-center gap-2">
                        <input id="rdbBDocsApproved" data-testid="dbDocsApproved" name="docStatus"
                          className="size-4 border rounded-full appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-green-500 checked:border-green-500 dark:checked:bg-green-500 dark:checked:border-green-500"
                          type="radio"
                          value="Verified"
                          onChange={validationBDoc.handleChange}
                          checked={validationBDoc?.values.docStatus === "Verified"}
                        />
                        <label htmlFor="rdbBDocsApproved" className="align-middle">
                          Approve
                        </label>
                      </div>

                      <div className="flex items-center gap-2">
                        <input id="rdbBDocsRejected" name="docStatus" className="size-4 border rounded-full appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-orange-500 checked:border-orange-500 dark:checked:bg-orange-500 dark:checked:border-orange-500"
                          type="radio"
                          value="Rejected"
                          onChange={validationBDoc.handleChange}
                          checked={validationBDoc?.values.docStatus === "Rejected"}
                        />
                        <label htmlFor="rdbBDocsRejected" className="align-middle">
                          Reject
                        </label>
                      </div>
                    </div>
                  </div>
                  {/* <div className="xl:col-span-12">
                      <textarea
                        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        id="documentRejectedReason"
                        name="documentRejectedReason"
                        rows={1}
                        placeholder="Status Comments"
                        onChange={validationBDoc.handleChange}
                        onBlur={validationBDoc.handleBlur}
                        value={validationBDoc.values.documentRejectedReason || ""}
                      />
                      {validationBDoc.touched.documentRejectedReason && validationBDoc.errors.documentRejectedReason ? (
                        <p className="text-red-400">{validationBDoc.errors.documentRejectedReason}</p>
                      ) : null}
                    </div> */}
                  <div className="xl:col-span-12">
                    <div className=" flex justify-end gap-2 " style={{ justifyItems: 'flex-end', alignItems: 'flex-end', alignContent: 'flex-end' }}>
                      <button
                        type="reset"
                        data-modal-close="addDocuments"
                        className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500"
                      >
                        Cancel
                      </button>

                      {!isBDocSaving ? (
                        <button
                          type="submit"
                          className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        >
                          {"Update"}
                        </button>

                      ) : (
                        <button
                          type="button"
                          disabled
                          className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        >
                          <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                          Saving...
                        </button>
                      )}
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div>

          <div className="card">
            <h4 className="text-15" style={{ marginLeft: 20, marginTop: 10 }} >Add Business Document</h4>

            <form action="#!" onSubmit={(e) => {
              e.preventDefault();
              validationNewBDoc.handleSubmit();
              return false;
            }}>
              <div className="card-body">
                <table style={{ width: '100%', border: 1 }}  >
                  <thead>
                    <tr >
                      <td style={{ width: '35%', fontWeight: 'bold', color: (validationNewBDoc.touched.documentName && validationNewBDoc.errors.documentName ? "red" : "gray") }}>Doc Type</td>
                      <td style={{ width: '25%', fontWeight: 'bold', color: (validationNewBDoc.touched.documentNumber && validationNewBDoc.errors.documentNumber ? "red" : "gray") }}>Doc Number</td>
                      <td style={{ width: '20%', fontWeight: 'bold', color: (validationNewBDoc.touched.documentUrl && validationNewBDoc.errors.documentUrl ? "red" : "gray"), paddingLeft: 50 }}  >File</td>
                      <td style={{ width: '20%', fontWeight: 'bold', color: 'gray' }} className=" flex justify-end "></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td >
                        <Select
                          className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                          options={documentNames}
                          name="documentName"
                          id="documentName"
                          value={selectedDocumentName}
                          onChange={e => { handleDocumentNameSelection(e) }}
                        />
                      </td>
                      <td >
                        <input id="documentNumber" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                          placeholder="Document Number"
                          name="documentNumber"
                          onChange={validationNewBDoc.handleChange}
                          onBlur={validationNewBDoc.handleBlur}
                          value={validationNewBDoc.values.documentNumber || ""}
                        />
                      </td>
                      <td >
                        <input type="file" id="file" style={{ display: 'none' }} onChange={onFileChange} />
                        <Link
                          to="#"
                          target="_blank"
                          className="flex items-center ml-4  justify-center size-8 transition-all duration-200 ease-linear rounded-md text-green-500 bg-green-100 hover:text-white hover:bg-green-500 dark:bg-green-500/20 dark:hover:bg-green-500"
                          onClick={() => document.getElementById('file')?.click()}
                        >
                          <UploadCloud className="inline-block size-4 ltr:mr-1 rtl:ml-1" />{"  "}
                        </Link>
                      </td>
                      <td >
                        <div className=" flex justify-end " >
                          {!isNewBDocSaving ? (
                            <button
                              key={"documentRejectedReason000" + 0}
                              type="submit"
                              className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                            > {"Submit"}
                            </button>

                          ) : (
                            <button
                              type="button"
                              disabled
                              className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                            >
                              <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                              Saving...
                            </button>
                          )}


                        </div>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </form>
          </div>
        </div>

        <div className="xl:col-span-6" style={{ marginTop: 10 }} >
          {businessDocs?.map((item, index) => {
            return (
              <div key={'business-doc-table-' + index} className="card">
                <div className="card-body">
                  <table style={{ width: '100%', border: 1 }}  >
                    <thead>
                      <tr >
                        <td style={{ width: '35%', fontWeight: 'bold', color: 'gray' }}>Doc Type</td>
                        <td style={{ width: '25%', fontWeight: 'bold', color: 'gray' }}>Doc Number</td>
                        <td style={{ width: '25%', fontWeight: 'bold', color: 'gray' }}>Submitted On</td>
                        <td style={{ width: '15%', fontWeight: 'bold', color: 'gray', paddingLeft: 50 }} className=" flex justify-end ">Url</td>
                      </tr></thead>
                    <tbody>
                      <tr>
                        <td style={{ width: '35%' }}> {item?.documentName}</td>
                        <td style={{ width: '25%' }}> {item.documentNumber}</td>
                        <td style={{ width: '25%' }}>{moment(item.documentVerifiedOn).format("DD/MM/YY")}</td>
                        <td style={{ width: '15%', paddingLeft: 50 }} className=" flex justify-end ">
                          {item?.documentUrl &&
                            <Link
                              to={getImageUrl(item?.documentUrl, 'businessDocument')}
                              target="_blank"
                              className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-green-500 bg-green-100 hover:text-white hover:bg-green-500 dark:bg-green-500/20 dark:hover:bg-green-500"
                            >
                              <Link2Icon className="inline-block size-4 ltr:mr-1 rtl:ml-1" />{" "}
                            </Link>
                          }
                        </td>
                      </tr>
                      <tr>

                        <td colSpan={2}>
                          <textarea
                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                            id={"documentRejectedReason" + index}
                            name={"documentRejectedReason" + index}
                            rows={1}
                            defaultValue={item.documentRejectedReason ?? ""}
                            onChange={(e) => handleDocCommentChange(index, e.target.value)}
                            placeholder="Status Comments" />
                        </td>
                        <td>
                          <div className="flex flex-wrap gap-2">

                            <div className="flex items-center gap-2">
                              <input id={"rdbDocApprove" + index} name={"InlineRadio" + index} className="size-4 border rounded-full appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-green-500 checked:border-green-500 dark:checked:bg-green-500 dark:checked:border-green-500"
                                type="radio" value={"true"}
                                checked={item.documentVerified}
                                onChange={(e) => handleDocStatusChange(index, e.target.value)}
                              />
                              <label htmlFor={"rdbDocApprove" + index} className="align-middle">
                                Approve
                              </label>
                            </div>

                            <div className="flex items-center gap-2">
                              <input id={"rdbDocReject" + index} name={"InlineRadio" + index} className="size-4 border rounded-full appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-orange-500 checked:border-orange-500 dark:checked:bg-orange-500 dark:checked:border-orange-500"
                                type="radio" value={"false"}
                                checked={item.documentVerified != null && !item.documentVerified}
                                onChange={(e) => handleDocStatusChange(index, e.target.value)}
                              />
                              <label htmlFor={"rdbDocReject" + index} className="align-middle">
                                Reject
                              </label>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className=" flex justify-end " >
                            <button
                              key={"documentRejectedReason" + index}
                              type="button"
                              className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                              onClick={() => handleDocStatusUpdate(index)}
                            > {"Update "}
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={4}>
                          {item.error ? (<p className="text-red-400">{item.error}</p>) : null}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )
          })
          }

        </div>

      </div>
    </React.Fragment>
  );
};
